import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function LanguageSwitcher({ className = "" }) {
  const { lang, toggleLang, t } = useLanguage();
  const otherLang = lang === "es" ? "EN" : "ES";
  const currentLang = lang === "es" ? "ES" : "EN";

  return (
    <button
      data-testid="lang-switcher"
      onClick={toggleLang}
      title={t("nav.toggleLang")}
      aria-label={t("nav.toggleLang")}
      className={`inline-flex items-center gap-1 rounded-md border border-zinc-200 bg-white px-2.5 py-1.5 font-mono text-[11px] uppercase tracking-widest text-zinc-600 hover:border-[#002FA7] hover:text-[#002FA7] transition-colors duration-200 ${className}`}
    >
      <span
        data-testid="lang-current"
        className="font-semibold text-[#002FA7]"
      >
        {currentLang}
      </span>
      <span className="text-zinc-300">/</span>
      <span data-testid="lang-other" className="text-zinc-400">
        {otherLang}
      </span>
    </button>
  );
}
